module.exports = __webpack_public_path__ + "static/media/Asset6.324b0683.png";